import { homeRoute, forgotPasswordRoute } from '../../core/routing/route-names';
import { AuthService } from '../services/auth.service';
import { OnInit, Component, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToastService } from '../services/toast.service';
import { LoginModel } from '../shared/login.model';
import { SpinnerService } from '../spinner/spinner.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { PasswordVisibilityDirective } from '../../directives/password-visibility.directive';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    imports: [TitleBarComponent, ReactiveFormsModule, AppErrorMessagesComponent, PasswordVisibilityDirective, NgIf, RouterLink, TranslateModule]
})
export class LoginComponent implements OnInit, OnDestroy {
  public loading = false;
  public loginModel: LoginModel = {} as LoginModel;

  public loginForm: UntypedFormGroup;
  public loginUserNameControl: UntypedFormControl;
  public loginPasswordControl: UntypedFormControl;
  public forgotPasswordRoute = forgotPasswordRoute;

  public errorFlag;
  private initFlag;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'body-login');
    this.spinnerService.showSpinner = false;
    this.initFlag = this.route.snapshot.queryParams.init;
    this.errorFlag = this.route.snapshot.queryParams.error;
    this.initializeForm();
    if (this.authService.isUserLoggedIn() && !this.initFlag) {
      this.router.navigate([homeRoute]);
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'body-login');
  }

  public login(): void {
    this.loading = true;

    this.loginModel.username = this.loginForm.value.userName;
    this.loginModel.password = this.loginForm.value.password;
    this.authService.login(this.loginModel).subscribe({
      next: (result) => {
        this.loading = false;
        if (result) {
          if (this.authService.redirectUrl) {
            this.router.navigateByUrl(this.authService.redirectUrl);
          } else {
            this.router.navigate([homeRoute]);
          }
        }
      },
      error: (error) => {
        this.loading = false;
        this.toastService.showApiExeption(error, 'i18n.core.messages.login.title', 'i18n.core.messages.login.message');
      }
    });
  }

  private initializeForm(): void {
    this.loginUserNameControl = new UntypedFormControl(null, [Validators.required]);
    this.loginPasswordControl = new UntypedFormControl(null, [Validators.required]);
    this.loginForm = new UntypedFormGroup({
      userName: this.loginUserNameControl,
      password: this.loginPasswordControl
    });
  }
}
